import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8462aa58&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseCollapseItem: require('/home/vsts/work/1/a/NuxtApp/components/base/CollapseItem.vue').default,ProductRating: require('/home/vsts/work/1/a/NuxtApp/components/product/Rating.vue').default,ProductDetailInformationReviews: require('/home/vsts/work/1/a/NuxtApp/components/product/detail/information/Reviews.vue').default,BaseCollapse: require('/home/vsts/work/1/a/NuxtApp/components/base/Collapse.vue').default})
